import React, { type JSX } from 'react'
import classNames from 'classnames'
import SvgInfo from '../../svg/info.svg'
import { IconProps } from '../icon-props'

const InfoIcon = ({
  className = '',
  multiLayered = false,
  ...props
}: IconProps): JSX.Element | null => (
  <SvgInfo
    {...props}
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    className={classNames('i-info', className, {
      'i-multi-layered': multiLayered,
    })}
  />
)

export default InfoIcon
